import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Checkbox, Paper, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Button, ButtonGrey } from "../../../style/Button";
import { ModalButton } from "../../../style/ModalButton";
import TitlDollar from "../../../assets/dollar.png";
import DollarGrey from "../../../assets/dollargrey.png";
import { Image2 } from "../../../style/Logo";
import "./select.css";
import medImg from "../../../../src/assets/pharmcy/Copay Medizen.jpg";
import priImg from "../../../../src/assets/pharmcy/Copay Primera.png";
import { ImageDollor, PricingTable } from "../../../style/PMCStyle/PMCPricing";
import { useHistory } from "react-router-dom";
import { useTheme } from "styled-components";
import PayAs from "./../../../assets/Pmc/Ads/Asset-22.png";

function getModalStyle() {
  return {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 600,
    maxWidth: "90vw",
    maxHeight: "92vh",
    height: "92vh",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #808080",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: 0,
    overflowY: "auto",
    overflowX: "hidden",
  },
  heading: {
    color: "#0389fb",
    fontSize: 15,
    fontFamily: "work sans",
    display: "flex",
    paddingBottom: 10,
    paddingLeft: 10,
  },
  sample: {
    backgroundColor: "#03b3fb",
    fontSize: 10,
    fontWeight: "Bold",
    paddingTop: 0,
    margin: 10,
    height: 20,
    padding: "0px",
    width: "180px",
    color: "white",
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
  column: {
    marginLeft: 25,
    borderBottom: "0.5px solid #808080",
  },
  box1: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 50,
    borderRight: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 145,
    boxShadow: "none",
  },
  box2: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 60,
    marginTop: -5,
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 155,
    backgroundColor: "#666666",
    boxShadow: "none",
  },
  box3: {
    display: "block",
    float: "right",
    marginBottom: 10,
    height: 50,
    borderLeft: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 165,
    boxShadow: "none",
  },

  Button1: {
    fontWeight: "600",
    fontFamily: "work sans",
    textAlign: "center",
    backgroundColor: "#f2f2f2",
    borderRadius: 25,
    width: 120,
    textTransform: "none",
    Display: "Block",
    float: "right",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    margin: 6,
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#03b3fb",
      color: "white",
    },
  },
  Button2: {
    fontWeight: "600",
    fontFamily: "work sans",
    textAlign: "center",
    backgroundColor: "#03b3fb",
    borderRadius: 25,
    color: "White",
    width: 100,
    Display: "Block",
    float: "right",
    textTransform: "none",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    marginRight: 20,
    margin: 6,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
}));

export default function Medication() {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [isDispensed, setIsDispensed] = React.useState(false);
  const [rowsState] = React.useState([]);
  let [medarrayState] = React.useState([]);
  const [constructorHasRun, setConstructorHasRun] = React.useState(false);
  const history = useHistory();

  const handleOpen = () => {
    setOpen(true)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseParentInfo = () => {
    setIsDispensed(true)
  };

  const dispensedPopuphandleClose = () => {
    setIsDispensed(prev=>!prev)
    history.push("/Pmc/dispensed")
  };
  const dispensedPopup = (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 2000,
  }}>

    <div
      className="dispensedPopUp"
      style={{
        width: "500px",
        height: "250px",
        backgroundColor: "#15BEEE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
        textAlign: "center",
        position: "relative",
      borderRadius:"1rem",
      backgroundImage: "linear-gradient(315deg, #4678ED 0%, #51BEEE 74%)",

      }}
      >
      <h3 style={{color:"white"}}>Prescription Dispensed</h3>
      <button
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          cursor: "pointer",
          fontSize: "20px",
          background: "none",
          border: "none",
        }}
        onClick={dispensedPopuphandleClose}
        >
        &times;
      </button>
    </div>
        </div>
  );

  const body = (
    <div style={modalStyle} className={`${classes.paper} pricingModal`}>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          style={{
            borderBottom: ".5px solid #d8d6d6",
            paddingTop: 20,
            paddingLeft: 36,
          }}
        >
          <Typography
            style={{
              color: "#4678ED",
              fontWeight: 600,
              marginTop: "0px",
              fontSize: "19px",
              marginBottom: "12px",
              fontFamily: "work sans",
            }}
          >
            Prescription Confirmation{" "}
            <span
              style={{
                fontWeight: "bolder",
                color: "black",
                float: "right",
                paddingRight: "30px",
              }}
            ></span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: 0,
            marginBottom: 15,
          }}
        >
          <Typography
            style={{
              padding: 10,
              fontSize: 19.5,
              fontWeight: 600,
              color: "#58595B",
              width: "100%",
              fontFamily: "work sans",
            }}
          >
            Medication samples and coupons delivered right to your office.{" "}
            <span style={{ color: "#0389fb" }}>Free. Easy. Fast.</span>
          </Typography>

          <Typography
            className="popup-sample-copy"
            style={{
              fontSize: 12.11,
              fontWeight: 400,
              paddingLeft: 10,
              marginTop: -10,
              width: "100%",
              fontFamily: "work sans",
            }}
          >
            Request multiple products from a variety of suppliers, prescription
            saving cards, and get access to vouchers.
            <br /> Want to see the samples available to you? Find out now!
          </Typography>
          <Button
            className={classes.sample}
            style={{
              backgroundColor: "rgb(21, 190, 238)",
              color: "#fff",
              fontSize: "12.11px",
              padding: "4px 17px",
              width: "auto",
              height: "auto",
              fontWeight: "500",
              fontFamily: "work sans",
              borderRadius: "16px",
            }}
          >
            Learn more at sample center
          </Button>
        </Grid>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -10,
            marginBottom: 15,
          }}
        >
          <Grid item xs={4}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTopt: 20,
                color: "#606060",
                fontFamily: "work sans",
              }}
            >
              Pick Up Location
              <br />
              <span style={{ fontWeight: 300, marginTop: 5 }}>
                Phone: 703-205-7034
                <br />
                Fax: 703-205-7035
              </span>
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTopt: 20,
                color: "#606060",
                fontFamily: "work sans",
              }}
            >
              VA Pharmacy 10.6MU
              <br />
              <span style={{ fontWeight: 300, marginTop: 5 }}>
                7723 Jefferson Davis Highway
                <br />
                Arlington, VA 22201
              </span>
            </Typography>
          </Grid>
        </Grid>
        <PricingTable
          style={{
            fontSize: "15.52px",
            margin: "0 30px 30px",
            borderBottom: "0.5px solid rgb(128, 128, 128)",
          }}
        >
          <thead>
            <tr>
              <th>Prescriptions Sent</th>
              <th>Status</th>
              <th>
                <Checkbox />
                Coupon
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="purpleText" style={{ fontWeight: "400" }}>
                Medizen 10 MG Oral Tablet
              </td>
              <td className="pendingText" style={{ fontWeight: "400" }}>
                Pending
              </td>
              <td className="greenText" style={{ fontWeight: "400" }}>
                <ImageDollor src={TitlDollar} alt="Dollor" /> Coupon/Guide
                Available
              </td>
            </tr>
            <tr>
              <td colSpan={3} className="pendingText" style={{ fontWeight: "400",textAlign:"right" }} >
                 <img src={PayAs} className="imgPopupTable" />
              </td>
            </tr>
            <tr>
              <br />
            </tr>
          </tbody>
        </PricingTable>
        {rowsState.map((name) => name)}
        <Grid item xs={12} className="pricingButtons">
          <Button
            className="billing-btn-primary billing-btn-wide"
            onClick={handleCloseParentInfo}
          >
            Dispense
          </Button>
          <Button
            className="billing-btn-outline billing-btn-wide"
          >
            Print Summary
          </Button>
        </Grid>
      </Grid>
    </div>
  
  );

  return (
    <div>
      <Button
        className="billing-btn-primary"
        height="fit-content"
        onClick={handleOpen}
      >
        Dispense
      </Button>
      {open && <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>}
      {isDispensed && dispensedPopup}

      <br />
    </div>
  );
}
